import { render, staticRenderFns } from "./ModalEditarPlano.vue?vue&type=template&id=1815c338&"
import script from "./ModalEditarPlano.vue?vue&type=script&lang=js&"
export * from "./ModalEditarPlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports